export default __webpack_public_path__ + "static/media/icon_cerrar.da72a75a.svg";